import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerSearch = _resolveComponent("TablerSearch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-flex tw-h-8 tw-flex-none tw-rounded-lg tw-transition-all", {
      'tw-w-[240px] tw-border tw-bg-white focus-within:tw-border-deep-orange-600 dark:tw-bg-black': _ctx.isOpen,
      'tw-w-8 tw-items-center tw-justify-center tw-border hover:tw-border-deep-orange-50 hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600':
        !_ctx.isOpen,
      '!tw-w-full': _ctx.alwaysExpanded
    }])
  }, [
    _createElementVNode("button", {
      "data-testid": "studio-search-button",
      class: _normalizeClass({
        'tw-inline-flex tw-h-8 tw-w-8 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg': true,
        'tw-tw-cursor-default hover:tw-text-deep-orange-600': _ctx.isOpen,
        'hover:tw-border-deep-orange-50 hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600': !_ctx.isOpen
      }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInput && _ctx.toggleInput(...args)))
    }, [
      _createVNode(_component_TablerSearch, { class: "tw-mt-0 tw-h-5 tw-w-5" })
    ], 2),
    _withDirectives(_createElementVNode("input", {
      ref: "searchInput",
      "data-testid": "studio-search-input",
      type: "search",
      class: "tw-h-8 tw-w-full tw-self-stretch tw-overflow-visible tw-rounded-full tw-border-none tw-bg-transparent tw-pl-1 tw-pr-1 tw-text-sm tw-leading-4 focus:tw-border-none focus:tw-outline-none focus:tw-ring-0",
      value: _ctx.searchTerm,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, _hoisted_1), [
      [_vShow, _ctx.isOpen]
    ])
  ], 2))
}